import { render, staticRenderFns } from "./ProductInstruction.vue?vue&type=template&id=54b04052&scoped=true"
import script from "./ProductInstruction.vue?vue&type=script&lang=js"
export * from "./ProductInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b04052",
  null
  
)

export default component.exports